export default __webpack_public_path__ + "static/media/uolhost-horizontal.cec030ba.svg";